import { motion } from "framer-motion";

// Subtle scroll-triggered fade + slide-up reveal.
export const Reveal = ({ children, delay = 0, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.21, 0.5, 0.35, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);
